// Accounting Expenses Types Vuex

import state from './remittanceStates.js'
import * as getters from './remittanceGetters.js'
import * as mutations from './remittanceMutations.js'
import * as actions from './remittanceActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
